import { InputHTMLAttributes } from 'react';

import Box from '@mui/material/Box';

import './styles.scss';

export interface CheckboxProps {
  label?: string;
  checkboxProps?: InputHTMLAttributes<HTMLInputElement>;
}

export function Checkbox({ label, checkboxProps }: CheckboxProps) {
  return (
    <label className="checkbox-container">
      <input {...checkboxProps} type="checkbox" />
      <Box className="text" component="span">
        {label}
      </Box>
      <span className="checkbox-icon-container">
        <CheckMarkIcon />
      </span>
    </label>
  );
}

const CheckMarkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect width="16" height="16" rx="2" fill="#0470DE" />
    <path
      d="M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z"
      fill="white"
    />
  </svg>
);
